import { axiosClassic } from "../api";

export interface IMessage {
  id: number;
  title: string;
  textHtml: string;
  publicationDate: string;
}

class MessagesService {
  private BASE_URL = "/messages";

  async getAll() {
    const { data } = await axiosClassic.get<IMessage[]>(this.BASE_URL);
    return data;
  }
}

export const messagesService = new MessagesService();